import { render } from "./EditArticlePage.vue?vue&type=template&id=5d14894e&ts=true"
import script from "./EditArticlePage.vue?vue&type=script&lang=ts"
export * from "./EditArticlePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__